import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export type LinkRow = {
  id?: string;
  item_key: string;
  label: string;
  href: string;
  sub?: string | null;
  icon?: string | null;
  color_var?: string | null;
  external: boolean;
  enabled: boolean;
  position: number;
};

export const getLinkSet = createServerFn({ method: "GET" })
  .inputValidator((input: unknown) =>
    z.object({ setKey: z.string().min(1).max(64) }).parse(input),
  )
  .handler(async ({ data }): Promise<LinkRow[]> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: rows, error } = await supabaseAdmin
      .from("content_link_sets")
      .select("id,item_key,label,href,sub,icon,color_var,external,enabled,position")
      .eq("set_key", data.setKey)
      .eq("enabled", true)
      .order("position", { ascending: true });
    if (error) return [];
    return (rows ?? []) as LinkRow[];
  });

export const getText = createServerFn({ method: "GET" })
  .inputValidator((input: unknown) =>
    z.object({ key: z.string().min(1).max(128) }).parse(input),
  )
  .handler(async ({ data }): Promise<string | null> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: row, error } = await supabaseAdmin
      .from("content_text")
      .select("value")
      .eq("text_key", data.key)
      .maybeSingle();
    if (error) return null;
    return (row?.value as string | undefined) ?? null;
  });